import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * The PriiLiveActivity native plugin (ios/App/App/PriiLiveActivityPlugin.swift): the lock screen card (Stage 6).
 * `sync` starts the event's card or updates it; `end` takes it down. Neither throws: an older native build without the
 * plugin, Android, or the web simply has no card.
 */
const PriiLiveActivity = registerPlugin('PriiLiveActivity');

const IS_IOS = Capacitor.getPlatform() === 'ios';

/** { ok, action?: 'started' | 'updated', reason? } */
export async function syncLiveActivity(eventId, state) {
  if (!IS_IOS) return { ok: false, reason: 'platform' };
  try {
    return await PriiLiveActivity.sync({ eventId, state });
  } catch (e) {
    return { ok: false, reason: String(e?.message || e) };
  }
}

export async function endLiveActivity() {
  if (!IS_IOS) return;
  try {
    await PriiLiveActivity.end();
  } catch {
    // an older native build
  }
}

export const LIVE_ACTIVITY_SUPPORTED = IS_IOS;
